import React from 'react';
import { useHistory } from 'react-router-dom';

import { imgLinks } from '../../shared';
import useInsuranceInfo from '../../hooks/useInsuranceInfo';
import { useCompanyLogo } from '../../hooks/useIcons';

import {
  StyledCompanyLogoButton,
  StyledDaDirektLogo,
  StyledHeaderLogoLinks,
} from './Header.styled';

function HeaderLogoLinks({ customer, trackDtEvent, showDaDirektImg }) {
  const history = useHistory();

  const { type: insuranceType } = useInsuranceInfo();
  const companyLogo = useCompanyLogo();

  const handleCompanyLogoClick = () => {
    trackDtEvent(`click ${insuranceType} logo`, customer)();
    history.push('/');
  };

  return (
    <StyledHeaderLogoLinks>
      <StyledCompanyLogoButton
        component="button"
        onClick={handleCompanyLogoClick}
        aria-label="go to homepage"
      >
        <img src={imgLinks[`${companyLogo}`]} alt={insuranceType} />
      </StyledCompanyLogoButton>

      {showDaDirektImg && (
        <StyledDaDirektLogo src={imgLinks['icon.menu.dadirekt.dark']} alt="DaDirekt" />
      )}
    </StyledHeaderLogoLinks>
  );
}

export default HeaderLogoLinks;
